import React from "react";
import useStyles from './styles';

import sim1Icon from '../../../../../assets/images/sim1.svg';
import sim2Icon from '../../../../../assets/images/sim2.svg';

const Sim = ({sim1, sim2, statusComponent1, statusComponent2}) => {

    const classes = useStyles();

    return (
        <div className={classes.container} id={`sim-container`} data-cy={`sim-container`}>
           {(!!sim1) ? <div className={classes.simElement} id={`sim-element1`} data-cy={`sim-element1`}><img alt={`sim1`} src={sim1Icon} id={`sim-element1-img`} data-cy={`sim-element1-img`}/>{statusComponent1}</div> : null}
           {(!!sim2) ? <div className={classes.simElement} id={`sim-element1`} data-cy={`sim-element1`}><img alt={`sim2`} src={sim2Icon} id={`sim-element2-img`} data-cy={`sim-element2-img`}/>{statusComponent2}</div> : null}
        </div>
    );
}

export default Sim;
